import React, { Component } from "react";
import { connect } from "react-redux";
import { View, StyleSheet, Dimensions } from "react-native";
import { translate } from "../locales/translate";
import RTSPPlayer from "../components/RTSPPlayer";

const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;
const SPINNER_SIZE = 32;
const MAX_REPEAT_ON_FAILURE = 2;
class CameraViewScreen extends Component {
  constructor(props) {
    super(props);
    let { cameraId, areaId, number } = this.props.navigation.state.params;
    this.player = undefined;
    this.state = {
      cameraId,
      areaId,
      number,
      paused: false,
      serverUrl: undefined,
      accessToken: undefined,
      videoSource: undefined,
      logs: undefined,
      retryOnFailure: 0,
      showLoading: true,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  connectToVideoServer = () => {
    console.log(
      "CameraViewScreen.connectToVideoServer(), retryOnFailure: ",
      this.state.retryOnFailure
    );
    this.clearLog();
    this.addLog(translate("app.pleaseWaite"));
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;

    var serverIp = serverUrl
      .replace(/https?:\/\//g, "") // remove schema
      .replace(/:[0-9]{3,6}\/?/g, ""); // remove port if exists.
    var videoSource = undefined;
    let { areaId, number, cameraId } = this.state;
    if (cameraId) {
      videoSource = `rtsp://${serverIp}:8556/live/${accessToken}/${cameraId}`;
    }

    if (!videoSource) {
      this.addLog(translate("camera.connectionFailed"));
    }
    this.setState({
      accessToken: accessToken,
      serverUrl,
      videoSource,
    });
  };

  componentDidMount() {
    console.log("CameraViewScreen.ComponentDidMount()");
    //this.connectToVideoServer();
  }

  componentWillUnmount() {
    this.setState({ paused: true });
  }

  addLog = (message) => {
    if (message) {
      // var t = new Date();
      // var m = `${t.getHours()}:${t.getMinutes()}:${t.getSeconds()}.${t.getMilliseconds()} \t ${message}`;
      // var _logs = [...this.state.logs, message];
      this.setState({ logs: message });
    }
  };

  clearLog = () => {
    if (this.state.logs) {
      console.log("clearing logs");
      this.setState({ logs: undefined });
    }
  };

  render() {
    let isPortrait = SCREEN_WIDTH < SCREEN_HEIGHT;
    return (
      <View style={isPortrait ? styles.container : {}}>
        <RTSPPlayer
          cameraId={this.state.cameraId}
          width={SCREEN_WIDTH}
          height={SCREEN_WIDTH * (9 / 16)}
          spinnerSize={SPINNER_SIZE}
          maxRepeatOnFailure={MAX_REPEAT_ON_FAILURE}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  logs: {
    color: "#ccc",
    textAlign: "center",
  },
  container: {
    flex: 1,
    backgroundColor: "#111",
    //paddingTop: 30,
    justifyContent: "center",
    // , alignItems : 'center'
  },
  playerStyle: {
    width: SCREEN_WIDTH,
    height: SCREEN_WIDTH * (9 / 16),
    borderColor: "#f00",
    borderWidth: 1,
    // alignSelf: "center"
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

export default connect(mapStateToProps)(CameraViewScreen);

// address samples:
// rtsp://admin:abcd4321@192.168.10.19:554/onvif1
// rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mov
// rtsp://192.168.10.16:8554/live/00000000-0000-0000-0000-000000000003
